import styled from 'styled-components';

export const ChildrenWrapper = styled.div`
  display: inline-flex;
  align-self: center;
`
